import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import classes from "./styles.module.css";
import Icon from "../../Utils/Icon";
import Loader from "../../Utils/Loader";

const STATUSES = [
    { value: "new", label: "Новый", color: "#1565c0" },
    { value: "in_progress", label: "В работе", color: "#e65100" },
    { value: "resolved", label: "Решен", color: "#2e7d32" },
    { value: "archived", label: "Архив", color: "#757575" },
];

function DisputeFilters({ onApplyFilters, isLoading }) {
    const [selectedStatuses, setSelectedStatuses] = useState([]);

    function handleStatusChange(value, checked) {
        if (checked) {
            setSelectedStatuses([...selectedStatuses, value]);
        } else {
            setSelectedStatuses(selectedStatuses.filter((s) => s !== value));
        }
    }

    function handleApply() {
        const filters = [];

        selectedStatuses.forEach((status) => {
            filters.push({ [status]: true });
        });

        onApplyFilters({
            filters: filters.length > 0 ? filters : [],
        });
    }

    function handleReset() {
        setSelectedStatuses([]);
        onApplyFilters({
            filters: [],
        });
    }

    return (
        <div className={classes.Card}>
            <div className={classes.Body}>
                {/* Statuses */}
                <div className={classes.Group}>
                    <h6 className={classes.Title}>
                        <FormattedMessage id="DisputeFilters.title.status" defaultMessage="Статус" />
                    </h6>
                    <div className={classes.Column}>
                        {STATUSES.map((status) => (
                            <div className={classes.CheckboxWrap} key={status.value}>
                                <input
                                    id={`status-${status.value}`}
                                    type="checkbox"
                                    checked={selectedStatuses.includes(status.value)}
                                    onChange={(e) => handleStatusChange(status.value, e.target.checked)}
                                />
                                <label htmlFor={`status-${status.value}`} className={classes.CustomCheckbox}>
                                    <div
                                        className={classes.StatusDot}
                                        style={{ backgroundColor: status.color }}
                                    />
                                    <span>{status.label}</span>
                                </label>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className={classes.Footer}>
                <button onClick={handleApply} className={classes.Submit} disabled={isLoading}>
                    {!isLoading ? (
                        <Icon className={classes.buttonIcon} icon="filter" size="17px" />
                    ) : (
                        <Loader isString={true} />
                    )}
                    <FormattedMessage id="DisputeFilters.btn.filter" defaultMessage="Фильтровать" />
                </button>
                <button onClick={handleReset} className={classes.Reset}>
                    <FormattedMessage id="DisputeFilters.btn.reset" defaultMessage="Сбросить" />
                </button>
            </div>
        </div>
    );
}

DisputeFilters.defaultProps = {
    isLoading: false,
    onApplyFilters: () => {},
};

export default DisputeFilters;



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/DisputeFilters/index.js